import type { FC } from 'react'
import classNames from 'classnames'

import { Text } from 'components'

import styles from './Hero.module.scss'

type TAccordionItemProps = {
  title: string
  content: string
  isOpen: boolean
  onToggle: () => void
  compact?: boolean
}

const AccordionItem: FC<TAccordionItemProps> = ({ title, content, isOpen, onToggle, compact }) => (
  <div
    className={classNames(styles.accordion__item, {
      [styles.accordion__item_open]: isOpen,
      [styles.accordion__item_compact]: compact,
    })}
  >
    <button type='button' className={styles.accordion__header} onClick={onToggle} aria-expanded={isOpen}>
        <Text text={title} className={styles.accordion__title} />
        <span className={styles.accordion__chevron} aria-hidden />
      </button>
      <div className={styles.accordion__panel}>
        <div className={styles.accordion__panelInner}>
          <Text text={content} className={styles.accordion__content} />
        </div>
      </div>
    </div>
  )

export default AccordionItem
